module.exports = __webpack_public_path__ + "static/img/page5.f7b093a1.jpg";